/*
 * *********************************************************************************************************************
 *  * Copyright (c) 2025 Fannie Mae. All rights reserved. Unpublished -- Rights  reserved under the copyright laws of the
 *  * United States and international conventions. Use of a copyright notice is precautionary only and does not imply
 *  * publication or disclosure. This software contains confidential information and trade secrets of Fannie Mae. Use,
 *  * disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.
 *  * ********************************************************************************************************************
 */

import('./bootstrap')
	.catch(err => console.error(err));
